import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../Link/Link';
import { useTranslation } from 'react-i18next';
import BetButton from '~spa/Components/BetButton';
import SwitchableOdds from '~spa/Components/SwitchableOdds';
import { getOddsBoostSelection } from '../utils';
import BetCardFooter from '../Widget/BetCardFooter';
import BetCardHeader from '../Widget/BetCardHeader';
import '../Widget/styles/oddsBoostWidget.scss';
import './ArticleOddsBoost.scss';

const ARTICLE_ODDS_BOOST_CLASS = 'article-odds-boost';

const ArticleOddsBoostSelecionViewer = ({
    oddsBoostProps,
}) => {

    const [t] = useTranslation();
    const {
        max_stake: maxStake,
        name: articleName,
        closeModal,
        id: selectionId,
        eventName,
        label,
        sp_only: spOnly,
        tradable,
        betable,
        decimal_price: decimalPrice,
        fraction_price: fractionPrice,
        american_price: americanPrice,
        sport_slug: sportSlug,
        scheduled_start: scheduledStart,
        eventUrl,
        gtmAttribute,
    } = oddsBoostProps;

    return (
        <div className={`${ARTICLE_ODDS_BOOST_CLASS}-wrapper`}>
            <Link to={eventUrl} className={`${ARTICLE_ODDS_BOOST_CLASS}-link`} onClick={closeModal}>
                <div className={`${ARTICLE_ODDS_BOOST_CLASS}-header`}>
                    <div className={`${ARTICLE_ODDS_BOOST_CLASS}-header__title`}>
                        <div className={`${ARTICLE_ODDS_BOOST_CLASS}-header__icon`}></div>
                        <div className={`${ARTICLE_ODDS_BOOST_CLASS}-header__text`}>
                            {`${t('odds_boost.odds_boost')}`}
                        </div>
                    </div>
                    <BetCardHeader />
                </div>
            </Link>
            <div className={`${ARTICLE_ODDS_BOOST_CLASS}-body`}>
                <Link to={eventUrl} className={`${ARTICLE_ODDS_BOOST_CLASS}-link`} onClick={closeModal}>
                    <div className={`${ARTICLE_ODDS_BOOST_CLASS}-main`}>
                        <div className={`${ARTICLE_ODDS_BOOST_CLASS}-main__title`}>
                            {articleName}
                        </div>
                        <div className={`${ARTICLE_ODDS_BOOST_CLASS}-main__event`}>
                            {eventName}
                        </div>
                        <BetCardFooter
                            startTime={scheduledStart}
                            maxStake={maxStake}
                        />
                    </div>
                </Link>
                <div className={`${ARTICLE_ODDS_BOOST_CLASS}-selections`}>
                    <Link to={eventUrl} className={`${ARTICLE_ODDS_BOOST_CLASS}-link`} onClick={closeModal}>
                        <div className={`${ARTICLE_ODDS_BOOST_CLASS}-selections__was`}>
                            <SwitchableOdds selection={getOddsBoostSelection(oddsBoostProps)} />
                        </div>
                    </Link>
                    <div className={`${ARTICLE_ODDS_BOOST_CLASS}-selections__now`}>
                        <BetButton
                            selection_id={String(selectionId)}
                            decimal_price={decimalPrice}
                            fraction_price={fractionPrice}
                            american_price={americanPrice}
                            betable={betable}
                            tradable={tradable}
                            sp_only={Boolean(Number(spOnly))}
                            sport_slug={sportSlug}
                            gtmAttribute={gtmAttribute}
                            label={label}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

ArticleOddsBoostSelecionViewer.propTypes = {
    oddsBoostProps: PropTypes.object.isRequired,
};

export default ArticleOddsBoostSelecionViewer;
